<template>
  <v-container>
    <v-row no-gutters class="primary--text">
      <v-col cols="12">
        <p class="info-breadcrumb primary--text body-2" v-if="breadCrumbsItems.length < 1">
          {{ $t('rellena_pasos') }}
        </p>
        <v-breadcrumbs v-if="breadCrumbsItems.length > 0" :items="breadCrumbsItems" divider="|"
                       class="pl-0"></v-breadcrumbs>
      </v-col>
    </v-row>

    <v-row no-gutters class="primary--text">
      <v-col cols="12" class="paso">
        <span class="font-weight-bold">{{ $t('paso', {paso: '0'}) }}</span>&nbsp;{{ $t('selec_tipo_obra') }}
      </v-col>
    </v-row>
    <v-row no-gutters class="primary--text tipo-obra">
      <v-col cols="6" v-for="(tipOb,index) in tiposDeObra" :key="index" class="pa-3">
        <v-btn block outlined x-large color="primary" class="primary--text"
               @click="seleccionarTipoObra(tipOb)"
               :class="{'secondary': seleccion.tipoObra && tipOb.codigo == seleccion.tipoObra.codigo}">
          {{ tipOb.nombre }}
        </v-btn>
      </v-col>
    </v-row>

    <v-row no-gutters class="primary--text">
      <v-col cols="12" class="paso">
        <span class="font-weight-bold">{{ $t('paso', {paso: '1'}) }}</span>&nbsp;{{ $t('selec_sol_cons') }}
      </v-col>
    </v-row>
    <v-row no-gutters class="primary--text solucion-constructiva">
      <v-col cols="12" v-if="solucionesConstructivas.length == 0">
        <p class="pl-8 subtitle-2 font-italic">{{ $t('selec_tipo_obra_primero') }}</p>
      </v-col>
      <v-col cols="12" class="d-flex flex-wrap">
        <div v-for="(sol,index) in solucionesConstructivas" :key="index" class="opcion-tipo-sc">
          <v-card outlined class="card-opcion ma-2"
                  @click="seleccionarSolCons(sol)"
                  :class="['pa-2', {'secondary': seleccion.solucionConstructiva && sol.codigo == seleccion.solucionConstructiva.codigo}]">

            <v-img :src="calcularSolConsImgSrc(sol)" contain class="pt-12" position="center bottom">
              <template v-slot:placeholder>
                <v-skeleton-loader type="image" min-width="180px" max-width="180px" min-height="160px"
                                   max-height="160px"/>
              </template>
              <v-list-item class="opcion-tipo-sc-texto">
                <v-list-item-content>
                  <v-list-item-title class="primary--text text-center"
                                     style="text-overflow: inherit; white-space: inherit">
                    {{ sol.nombre }}
                  </v-list-item-title>
                </v-list-item-content>
              </v-list-item>
            </v-img>
          </v-card>
        </div>
      </v-col>
    </v-row>

    <v-row no-gutters class="primary--text">
      <v-col cols="12" class="paso">
        <span class="font-weight-bold">{{ $t('paso', {paso: '2'}) }}</span>&nbsp;{{ $t('selec_ceramico') }}
      </v-col>
    </v-row>
    <v-row no-gutters class="primary--text">
      <v-col cols="12" v-if="seleccion.solucionConstructiva == null">
        <p class="pl-8 subtitle-2 font-italic">{{ $t('selec_sol_cons_primero') }}</p>
      </v-col>
      <v-col cols="12" class="d-flex flex-wrap">
        <selector-material :tip-sol-cons="seleccion.solucionConstructiva"
                           v-if="seleccion.solucionConstructiva && seleccion.ceramicoPers == null"
                           @change="seleccionarCeramico" @biblioteca-click="abrirBiblioteca" width="232"/>
        <div class="pa-0 ma-0 opcion-tipo-sc" v-if="seleccion.solucionConstructiva && seleccion.ceramicoPers">
          <v-card class="mano pa-0 ma-1" color="secondary" min-height="180px">
            <v-card-title class="text-center body-1 primary--text">
              {{ ceramicoPers.marca }} {{ ceramicoPers.coleccion }}
            </v-card-title>
            <v-card-text class="pa-1">
              <v-img :src="ceramicoPers.imagen" contain max-width="180px"/>
            </v-card-text>
          </v-card>
        </div>
      </v-col>
    </v-row>

    <v-row no-gutters class="primary--text">
      <v-col cols="12" class="paso">
        <span class="font-weight-bold">{{ $t('paso', {paso: '3'}) }}</span>&nbsp;{{ $t('selec_no_ceramico') }}
      </v-col>
    </v-row>
    <v-row no-gutters class="primary--text">
      <v-col cols="12" v-if="seleccion.solucionConstructiva == null">
        <p class="pl-8 subtitle-2 font-italic">{{ $t('selec_sol_cons_primero') }}</p>
      </v-col>
      <v-col cols="12">
        <selector-material :tip-sol-cons="seleccion.solucionConstructiva"
                           v-if="seleccion.solucionConstructiva && seleccion.noCeramicoPers == null"
                           :ceramicos="false" @change="seleccionarNoCeramico" @biblioteca-click="abrirBiblioteca"
                           width="232"/>
        <div class="pa-0 ma-0 opcion-tipo-sc" v-if="seleccion.solucionConstructiva && seleccion.noCeramicoPers">
          <v-card class="mano pa-0 ma-1" color="secondary" min-height="180px">
            <v-card-title class="text-center body-1 primary--text">
              {{ noCeramicoPers.marca }} {{ noCeramicoPers.coleccion }}
            </v-card-title>
            <v-card-text class="pa-1">
              <v-img :src="noCeramicoPers.imagen" contain max-width="180px"/>
            </v-card-text>
          </v-card>
        </div>
      </v-col>
    </v-row>

    <v-row no-gutters class="primary--text text-right">
      <v-col cols="12">
        <v-btn :disabled="!valido()" :loading="creandoProyecto" @click="crearProyecto()"
               class="ma-2" color="primary" rounded>
          {{ $t('crear_proyecto') }}
        </v-btn>
      </v-col>
    </v-row>
    <v-row no-gutters class="pt-4">
      <v-col cols="12">
        <p class="grey--text body-2">* {{ $t('infoProyecto') }}</p>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import {HttpHelper} from "@/comunes/helpers/HttpHelper";
import {VueRouteHelper} from "@/comunes/helpers/VueRouteHelper";
import ImagenesServicio from "../../comunes/servicios/ImagenesServicio";
import SelectorMaterial from "./Componentes/SelectorMaterial/SelectorMaterial";

export default {
  name: 'ProyectoNuevoPagina',
  components: {
    SelectorMaterial
  },
  props: {
    ceramicoPers: {type: Object, required: false, default: null},
    noCeramicoPers: {type: Object, required: false, default: null},
    uso: {type: Object, required: false, default: null},
  },
  data: () => ({
    seleccion: {
      tipoObra: null,
      solucionConstructiva: null,
      ceramico: null,
      ceramicoPers: null,
      noCeramico: null,
      noCeramicoPers: null
    },
    breadCrumbsItems: [],
    tiposDeObra: [],
    solucionesConstructivas: [],
    creandoProyecto: false
  }),
  mounted: function () {
    this.obtenerTiposDeObra();

    if (this.ceramicoPers) this.seleccion.ceramicoPers = this.ceramicoPers;
    if (this.noCeramicoPers) this.seleccion.noCeramicoPers = this.noCeramicoPers;
  },
  methods: {
    calcularBreadCrumb() {
      if (typeof this.seleccion == "undefined") {
        this.breadCrumbsItems = [];
        return;
      }

      let items = [];

      if (this.seleccion.tipoObra != null) items.push(this.seleccion.tipoObra.nombre);
      if (this.seleccion.solucionConstructiva != null) items.push(this.seleccion.solucionConstructiva.nombre);

      let ceramico = null;
      if (this.seleccion.ceramico != null) {
        ceramico = this.seleccion.ceramico.nombre;
      } else if (this.seleccion.ceramicoPers != null) {
        ceramico = `${this.seleccion.ceramicoPers.marca} ${this.seleccion.ceramicoPers.coleccion}`;
      }

      let noCeramico = null;
      if (this.seleccion.noCeramico != null) {
        noCeramico = this.seleccion.noCeramico.nombre;
      } else if (this.seleccion.noCeramicoPers != null) {
        noCeramico = `${this.seleccion.noCeramicoPers.marca} ${this.seleccion.noCeramicoPers.coleccion}`;
      }

      if (ceramico != null || noCeramico != null) {
        let ceramicoT = ceramico ? ceramico : "?";
        let noCeramicoT = noCeramico ? noCeramico : "?";
        items.push(`${ceramicoT} vs ${noCeramicoT}`);
      }

      let itemsBreadCrumb = [];
      items.forEach((item) => {
        itemsBreadCrumb.push({text: item});
      });
      this.breadCrumbsItems = itemsBreadCrumb;
    },
    calcularSolConsImgSrc(solCons) {
      return ImagenesServicio.imgTipoSolucionConstructivaS3(solCons.codigo);
    },
    seleccionarTipoObra(valor) {
      this.seleccion.tipoObra = valor;
      this.seleccion.solucionConstructiva = null;
      this.seleccion.ceramico = null;
      this.seleccion.noCeramico = null;

      this.obtenerTiposDeSolcons();
    },
    seleccionarCeramico(tipo, valor) {
      if (tipo == null) {
        this.seleccion.ceramico = null;
        return;
      }
      this.seleccion.ceramico = tipo === "personalizado" ? null : valor;
    },
    seleccionarNoCeramico(tipo, valor) {
      if (tipo == null) {
        this.seleccion.noCeramico = null;
        return;
      }

      this.seleccion.noCeramico = tipo === "personalizado" ? null : valor;
    },
    seleccionarSolCons(valor) {
      this.seleccion.solucionConstructiva = valor;
      this.seleccion.ceramico = null;
      this.seleccion.noCeramico = null;
    },
    obtenerTiposDeObra() {
      this.tiposDeObra = [];
      HttpHelper.get("tipos-obra")
          .then((tipos) => {
            this.tiposDeObra = tipos;
          })
          .finally(() => {
            if (this.uso && this.uso.referencias.length === 1) {
              this.seleccionarTipoObra(this.tiposDeObra[0])
            }
          })
    },
    obtenerTiposDeSolcons() {
      this.solucionesConstructivas = [];
      HttpHelper.get(`tipos-sol-cons/${this.seleccion.tipoObra.codigo}`)
          .then((tipos) => {
            this.solucionesConstructivas = tipos;
          }).finally(() => {
        if (this.uso) this.seleccionarSolCons(this.obtenerSolconsPers());
      })
    },
    obtenerSolconsPers() {
      for (let i = 0; i < this.solucionesConstructivas.length; i++) {
        if (this.solucionesConstructivas[i].clase.toUpperCase() === this.uso.referencias[0].toUpperCase()) {
          return this.solucionesConstructivas[i]
        }
      }
    },
    valido() {
      if (!this.seleccion) return false;
      if (this.seleccion.tipoObra == null) return false;
      if (this.seleccion.solucionConstructiva == null) return false;
      if (this.seleccion.noCeramicoPers == null && this.seleccion.noCeramico == null) return false;

      return this.seleccion.ceramicoPers != null || this.seleccion.ceramico != null;
    },
    volver() {
      VueRouteHelper.goTo("/", this.$router);
    },
    crearProyecto() {
      this.creandoProyecto = true;

      let params = {
        tipoObra: this.seleccion.tipoObra.codigo,
        solucionConstructiva: this.seleccion.solucionConstructiva.codigo,
        ceramico: this.seleccion.ceramico != null ? this.seleccion.ceramico.codigo : null,
        ceramicoPersId: this.seleccion.ceramicoPers != null ? this.seleccion.ceramicoPers.id : null,
        noCeramico: this.seleccion.noCeramico != null ? this.seleccion.noCeramico.codigo : null,
        noCeramicoPersId: this.seleccion.noCeramicoPers != null ? this.seleccion.noCeramicoPers.id : null,
      };

      const claveCompartir = this.$route.query["clave-compartir"] ? this.$route.query["clave-compartir"] : null;
      if (claveCompartir) params["claveCompartir"] = claveCompartir;

      HttpHelper.post(`proyecto`, params)
          .then((creadoId) => {
            VueRouteHelper.goTo(`/proyecto-detalles/${creadoId}`, this.$router);
          })
          .catch(() => {
            this.creandoProyecto = false;
          });
    },
    abrirBiblioteca(mat) {
      this.$router.push({
        name: 'biblioteca',
        params: {filtradoMaterial: mat, solucionConstructiva: this.seleccion.solucionConstructiva}
      });
    }
  },
  watch: {
    seleccion: {
      handler() {
        this.calcularBreadCrumb();
      },
      deep: true
    }
  },
};
</script>

<style lang="scss" scoped>
.container {
  max-width: 1185px;
}

.tipo-obra {
  .v-btn:not(.v-btn--round).v-size--x-large {
    font-size: 20px !important;
  }
}

.v-application.sm-down {
  .tipo-obra {
    .v-btn:not(.v-btn--round).v-size--x-large {
      font-size: 16px !important;
    }
  }

  .solucion-constructiva {
    .v-list-item {
      padding: 0 !important;

      .v-list-item__title {
        white-space: unset !important;
        min-height: 40px;
      }
    }

    .col-3 {
      max-width: 50% !important;
    }
  }
}

.v-application .secondary {
  border-color: #40108e !important;
}

.info-breadcrumb {
  padding: 18px 12px;
  margin: 0;
}

.v-card {
  border: 2px solid #40108e !important;
  cursor: url('../../assets/iconos/cursor.png'), auto !important;
}

.paso {
  font-size: 18px !important;
  margin-top: 10px;
  margin-bottom: 10px;
}

.card-opcion {
  /*margin-right: 10px;*/
  /*margin-top: 5px;*/
  cursor: pointer;
}

.opcion-tipo-sc {
  min-width: 232px;
  max-width: 232px;
}

.opcion-tipo-sc-texto {
  margin-top: -40px;
}

</style>

<!--@formatter:off-->
<i18n>
{
  "es": {
    "paso": "Paso {paso}.",
    "rellena_pasos": " ",
    "solo_pers": "Mostrar solo materiales personalizados",
    "selec_tipo_obra": "Seleccionar el tipo de obra",
    "selec_tipo_obra_primero": "Debes escoger un tipo de obra primero",
    "selec_sol_cons": "Escoger solución constructiva",
    "selec_sol_cons_primero": "Debes escoger un tipo de solución constructiva primero",
    "selec_ceramico": "Escoger un material cerámico",
    "selec_no_ceramico": "Escoger un material no cerámico",
    "msg_no_ceramico": "En esta sección se debe seleccionar el material no cerámico ya que el material cerámico siempre será evaluado.",
    "volver": "ATRÁS",
    "crear_proyecto": "SIGUIENTE",
    "infoProyecto": "Los datos procedentes de materiales genéricos han sido seleccionados de acuerdo con criterios objetivos y meramente técnicos. Para más información sobre el origen de estos datos ver el documento “Fuentes consultadas” disponible en el apartado de “Descargas”."
  }
}
</i18n>
<!--@formatter:on-->